import axiosInstance from 'api/axiosInstance';
import { URL_SCHEDULER_V4_PATROLS } from 'constants/urls';

/**
 * Update a single patrol assignment via the granular V4 API.
 * Only sends the fields that are provided. Does NOT touch other patrols.
 * If the patrol has already been started by a guard, checklists are preserved.
 *
 * @param {number} scheduleAssignmentId - The patrol's schedule_assignment_id
 * @param {Object} updates - Fields to update (all optional)
 * @param {number} [updates.CustomerId]
 * @param {number} [updates.AddressId]
 * @param {number} [updates.ContactId]
 * @param {string|Date} [updates.StartTime]
 * @param {string|Date} [updates.EndTime]
 * @param {string} [updates.Type]
 * @param {Array} [updates.Checklists] - Ignored if patrol already started
 * @returns {Promise<Object>} Updated patrol data from the API
 */
const updateSinglePatrol = async (scheduleAssignmentId, updates) => {
  try {
    const body = {};

    if (updates.CustomerId !== undefined) body.CustomerId = updates.CustomerId;
    if (updates.AddressId !== undefined) body.AddressId = updates.AddressId;
    if (updates.ContactId !== undefined) body.ContactId = updates.ContactId;
    if (updates.StartTime !== undefined) {
      body.StartTime = updates.StartTime instanceof Date ? updates.StartTime.toISOString() : updates.StartTime;
    }
    if (updates.EndTime !== undefined) {
      body.EndTime = updates.EndTime instanceof Date ? updates.EndTime.toISOString() : updates.EndTime;
    }
    if (updates.Type !== undefined) body.Type = updates.Type;
    if (updates.Checklists !== undefined) body.Checklists = updates.Checklists;

    const { data } = await axiosInstance({
      method: 'PUT',
      url: `${URL_SCHEDULER_V4_PATROLS}/${scheduleAssignmentId}`,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      data: body,
    });

    if (!data.success) {
      throw new Error(data.error?.message || 'Failed to update patrol');
    }

    return data.data;
  } catch (error) {
    console.error('[updateSinglePatrol] Failed for ID:', scheduleAssignmentId, error);
    throw error;
  }
};

export default updateSinglePatrol;
